import React, { useEffect } from "react";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/salesSaga";
import CustomDateRanges from "./smartComponents/customDateRanges";
import DatePicker from "./smartComponents/datePicker";
import NumberDisplay from "../../../components/moneyDisplay/moneyDisplay";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import PieChart from "../../../components/pieChart/pieChart";
import { StaffSalesTable } from "./smartComponents/StaffSalesTable";
import LearnMore from "../../../components/learnMore/learnMore";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import "./staffSales.scss";

const StaffSales = (props) => {
  const initialRequest = useSelector((state) => state.staffSales.initialRequest);
  const isUpdating = useSelector((state) => state.staffSales.isUpdating);
  const dataPoints = useSelector((state) => state.staffSales.dataPoints);
  const isLoading = useSelector((state) => state.staffSales.isLoading);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);
  const { revenuePieChart = [], revenueCategoriesPieChart = [] } = useSelector(
    (state) => state.staffSales.pieCharts
  );

  const currencySymbol = useSelector((state) => state.commonReducer.commonProps.currencySymbol);

  const formattedDataPoints = [dataPoints.slice(0, 3), dataPoints.slice(3)];

  const dispatch = useDispatch();

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchData(props));
    }
  }, []);

  const content = () => {
    return (
      <div id="staffSales">
        <div className="edit-selections-bar">
          <div className="select-box-no-width date-range-select-box">
            <p className="offers-title">Date Range</p>
            <CustomDateRanges />
          </div>

          <div className="date-select-box multi">
            <p className="offers-title">Date</p>
            <DatePicker />
          </div>

          <UpdateBtns />
        </div>

        {!isUpdating ? (
          <>
            <div className="data-points">
              {dataPoints &&
                formattedDataPoints.map((dataPoints, ind) => (
                  <div className="data-points__section" key={ind}>
                    {dataPoints.map((dataPoint) => (
                      <div key={dataPoint.label} className="data-points__elem">
                        <SectionContainer title={dataPoint.label}>
                          <NumberDisplay
                            value={dataPoint.value}
                            url={dataPoint.link ? dataPoint.link : ""}
                            disableAnimation={isUserQa}
                          />
                        </SectionContainer>
                      </div>
                    ))}
                  </div>
                ))}
            </div>
            {revenuePieChart.length !== 0 && revenueCategoriesPieChart.length !== 0 ? (
              <div className="pie-chart">
                <div className="pie-chart__el">
                  <PieChart
                    data={revenuePieChart}
                    width={675}
                    height={300}
                    responsive={false}
                    showLegend
                    legendPosition="right"
                    showPercent
                  />
                </div>
                <div className="pie-chart__el">
                  <PieChart
                    data={revenueCategoriesPieChart}
                    width={675}
                    height={300}
                    addOtherLabel
                    isSortable
                    showLegend
                    legendPosition="right"
                    isLegendTooltip
                    showPercent
                    legendTooltipPosition="left"
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <StaffSalesTable />
          </>
        ) : (
          <LoadingAnimation text="Updating data..." />
        )}
      </div>
    );
  };
  return (
    <SectionToggle
      isLoading={isLoading}
      title="Staff Sales and Conversions"
      content={content()}
      learnMore={
        <LearnMore title="Staff Sales and Conversions" content={learnMoreContent(currencySymbol)} />
      }
    />
  );
};

const learnMoreContent = (currencySymbol) => {
  return (
    <>
      Track employee sales and conversions based on their contact logs from ClubReady <br />
      <br />
      <b>Total Conversion: </b> All conversions during the time frame selected. All package sale
      that is tagged in iKizmet will be counted. Both Membership and Packages (no membership tag)
      are included. All mapping tags are based on brand level direction.
      <br />
      <br />
      <b>Package Conversion: </b> This metric will only show Package conversions during the time
      frame selected. <br />
      <br />
      <b>Membership Conversion: </b> This metric will only show Membership conversions during the
      time frame selected. <br />
      <br />
      <b>Average Activities to Package Conversion: </b>
      We will take all Package conversions and add up all the activities prior to the conversion. We
      will then divide by the number of conversions to get an average. <br />
      <br />
      <b>Average Activities to Membership Conversion: </b> We will take all Membership conversions
      and add up all the activities prior to the conversion. We will then divide by the number of
      conversions to get an average. <br />
      <br />
      <b>Average Days to Package Conversion: </b> We will take all Package conversions and add up
      all the days from the lead (profile creation date) to conversion. We will then divide by the
      number of conversions to get an average. <br />
      <br />
      <b>Average Days to Membership Conversion: </b>We will take all Membership conversions and add
      up all the days from the lead (profile creation date) to conversion. We will then divide by
      the number of conversions to get an average.
      <br />
      <br />
      <b>Sales Pie Chart: </b> This displays the percentage of Membership vs Package sales. You will
      see the sign in parentheses ({currencySymbol}) when you hover over the slice. <br />
      <br />
      <b>Category Pie Chart: </b> This displays the percentage of Membership vs Package sales based
      on their iKizmet secondary revenue category. This is not showing the Primary category. <br />
      <br />
      <b>Staff Conversion Table: </b> Each staff member (online included) that was part of a
      conversion during the timeframe selected will be displayed individually on a separate line.
      <br /> Each team members row will show the following columns <br />
      <br />
      1. Gross Sales: Total sales revenue
      <br />
      2. Total Conversions: Total number of conversions to both membership & packages.
      <br />
      3. Membership Sales: Only membership sales revenue
      <br />
      4. Memberships Sold: Total number of conversions to membership.
      <br />
      5. Activities: Total number of activities it took to make all conversions attributed to this
      staff member.
      <br />
      6. Avg # of Activities: The average number of activities attributed to this staff member it
      took to make the conversions. <br />
      7. Total Conversion Activities: Total number of activities it took to make all conversions
      attributed to ALL staff members including the one listed. <br />
      8. Total Avg # of Activities: Total number of activities attributed to ANY staff member
      (including the one listed) it took to make the conversions. <br />
    </>
  );
};

export default React.memo(StaffSales);
